// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Breadcrumb_breadcrumb__ll2xd {
  font-size: var(--text-sm);
}

.Breadcrumb_breadcrumb__list__7BwAG {
  display: flex;
  align-items: center;
  flex-flow: row wrap;
}

.Breadcrumb_breadcrumb__path__I9-Bs {
  font-weight: 500;
  color: var(--gray-extra-dark);
}

.Breadcrumb_breadcrumb__path--clickable__A6gmS {
  color: var(--primary-color);
}

.Breadcrumb_breadcrumb__path__I9-Bs:not(:first-child)::before {
  content: ">";
  display: inline-block;
  margin-inline-start: 1rem;
  margin-inline-end: 1.3rem;
  color: var(--gray-extra-dark);
}
`, "",{"version":3,"sources":["webpack://./src/components/UI/Breadcrumb/Breadcrumb.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,6BAA6B;AAC/B","sourcesContent":[".breadcrumb {\n  font-size: var(--text-sm);\n}\n\n.breadcrumb__list {\n  display: flex;\n  align-items: center;\n  flex-flow: row wrap;\n}\n\n.breadcrumb__path {\n  font-weight: 500;\n  color: var(--gray-extra-dark);\n}\n\n.breadcrumb__path--clickable {\n  color: var(--primary-color);\n}\n\n.breadcrumb__path:not(:first-child)::before {\n  content: \">\";\n  display: inline-block;\n  margin-inline-start: 1rem;\n  margin-inline-end: 1.3rem;\n  color: var(--gray-extra-dark);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breadcrumb": `Breadcrumb_breadcrumb__ll2xd`,
	"breadcrumb__list": `Breadcrumb_breadcrumb__list__7BwAG`,
	"breadcrumb__path": `Breadcrumb_breadcrumb__path__I9-Bs`,
	"breadcrumb__path--clickable": `Breadcrumb_breadcrumb__path--clickable__A6gmS`
};
export default ___CSS_LOADER_EXPORT___;
